const SplitTestConstants = {
  ZRM_VALUE_OF_PREMIUM: 'zrm-value-of-premium',
} as const;

export default SplitTestConstants;
